export const PAGE_SIZE = 25;
export const MAX_BULK_TEMPLATE_TITLE_LENGTH = 35;

export const DisplayStatus = {
  active: "Active",
  active_pending: "Active (pending)",
  archived: "Archived",
  pending_approval: "Pending approval",
  rejected: "Rejected",
};

export const EMPTY_FILTER_QUERY = {
  state_in: [],
  name: undefined,
};
